import { call } from "../../tsrpc";
import { ReqDisableAdRevenueConfig } from "../../shared/protocols/editor/PtlDisableAdRevenueConfig";
import { ReqGetAdRevenueConfigs } from "../../shared/protocols/editor/PtlGetAdRevenueConfigs";
import { ReqGetAdRevenueReportRecords } from "../../shared/protocols/editor/PtlGetAdRevenueReportRecords";
import { ReqRetryAdRevenueReports } from "../../shared/protocols/editor/PtlRetryAdRevenueReports";
import { ReqSaveAdRevenueConfig } from "../../shared/protocols/editor/PtlSaveAdRevenueConfig";

type AdminRequest<T extends { timestamp: number; token?: string }> = Omit<T, "timestamp" | "token">;

function withAuth<T extends object>(request: T): T & { timestamp: number; token: string } {
  return {
    ...request,
    timestamp: Date.now(),
    token: localStorage.getItem("token") || "",
  };
}

function fail(errorMessage: string, cause?: unknown): never {
  if (cause instanceof Error && cause.message && cause.message !== errorMessage) {
    throw new Error(`${errorMessage}：${cause.message}`);
  }
  throw new Error(errorMessage);
}

export async function getAdRevenueConfigs(request: AdminRequest<ReqGetAdRevenueConfigs>) {
  const result = await call("editor/GetAdRevenueConfigs", withAuth(request))
    .catch((error) => fail("收益配置加载失败", error));
  if (!result.isSucc) fail(result.err?.message || "收益配置加载失败");
  return result.res.data;
}

export async function saveAdRevenueConfig(request: AdminRequest<ReqSaveAdRevenueConfig>) {
  const result = await call("editor/SaveAdRevenueConfig", withAuth(request))
    .catch((error) => fail("收益配置保存失败", error));
  if (!result.isSucc) fail(result.err?.message || "收益配置保存失败");
  return result.res.data;
}

export async function disableAdRevenueConfig(request: AdminRequest<ReqDisableAdRevenueConfig>) {
  const result = await call("editor/DisableAdRevenueConfig", withAuth(request))
    .catch((error) => fail("收益配置停用失败", error));
  if (!result.isSucc) fail(result.err?.message || "收益配置停用失败");
  return result.res.data;
}

export async function getAdRevenueReportRecords(request: AdminRequest<ReqGetAdRevenueReportRecords>) {
  const result = await call("editor/GetAdRevenueReportRecords", withAuth(request))
    .catch((error) => fail("腾讯变现上报明细加载失败", error));
  if (!result.isSucc) fail(result.err?.message || "腾讯变现上报明细加载失败");
  return result.res.data;
}

export async function retryAdRevenueReports(request: AdminRequest<ReqRetryAdRevenueReports>) {
  const result = await call("editor/RetryAdRevenueReports", withAuth(request))
    .catch((error) => fail("重试任务提交失败", error));
  if (!result.isSucc) fail(result.err?.message || "重试任务提交失败");
  return result.res.data;
}
